// src/components/layout/Sidebar.js
import React from 'react';
import { Nav , Image, Button} from 'react-bootstrap';
import { Link,useLocation  } from 'react-router-dom';// Or use Link from react-router-dom and style manually
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';
// Import icons for sidebar items
import {
    FaTachometerAlt, FaHandHoldingUsd, FaMoneyCheckAlt, FaChartBar, FaFileInvoiceDollar,
    FaUsers, FaUserTag, FaListAlt, FaCog, FaCalculator, FaUserTie, FaScroll, FaBook, FaThList,
    FaUserFriends, FaUsersCog, FaRegComments, FaChartPie, FaTasks, FaBullseye, FaPaste,
    FaProjectDiagram, FaRoute, FaBell, FaBolt, FaFileUpload, FaTools ,FaBars,FaTimes
} from 'react-icons/fa'; // Example icons
const placeholderAvatar = "/logo192.png";
// Map keys to icons
const iconMap = {
    dashboard: FaTachometerAlt,
    loans: FaHandHoldingUsd,
    borrowers: FaUsers,
    payments: FaMoneyCheckAlt,
    fees: FaFileInvoiceDollar,
    escrowInfo: FaCalculator, // No dedicated link, often part of loan detail
    investors: FaUserTie,
    remittances: FaChartBar,
    coaMappings: FaBook,
    journalEntries: FaScroll,
    reconciliation: FaThList, // Changed icon
    auditLog: FaListAlt,
    users: FaUsers, // Shared icon
    roles: FaUserTag,
    lookups: FaThList, // Shared icon
    settings: FaCog,
};


// Define navigation links and roles that can access them
const navLinks = [
  { path: "/dashboard", labelKey: "dashboard", icon: "dashboard", roles: ['admin', 'manager', 'staff', 'accountant'] },

  { isHeader: true, labelKey: "management", roles: ['admin', 'manager', 'staff', 'accountant'] },
  { path: "/loans", labelKey: "loans", icon: "loans", roles: ['admin', 'manager', 'staff', 'accountant'] },
  { path: "/borrowers", labelKey: "borrowers", icon: "borrowers", roles: ['admin', 'manager', 'staff', 'accountant'] },
  { path: "/payments", labelKey: "payments", icon: "payments", roles: ['admin', 'manager', 'accountant', 'staff'] },
  { path: "/fees", labelKey: "fees", icon: "fees", roles: ['admin', 'manager', 'accountant', 'staff'] },
  { path: "/investors", labelKey: "investors", icon: "investors", roles: ['admin', 'manager', 'accountant'] },
  { path: "/remittances", labelKey: "remittances", icon: "remittances", roles: ['admin', 'manager', 'accountant'] },
  
  { isHeader: true, labelKey: "analysisConfig", roles: ['admin', 'manager', 'accountant'] },
  { path: "/reports", labelKey: "reports", roles: ['admin', 'manager'] }, // Example restriction
  { path: "/coa-mapping", labelKey: "coaMappings", icon: "coaMappings", roles: ['admin', 'accountant'] },
  { path: "/journal-entries", labelKey: "journalEntries", icon: "journalEntries", roles: ['admin', 'accountant'] },
  { path: "/reconciliation", labelKey: "reconciliation", icon: "reconciliation", roles: ['admin', 'accountant'] },
  { path: "/audit-log", labelKey: "auditLog", icon: "auditLog", roles: ['admin', 'accountant'] },
  // Accounting Section Separator (Optional)
  // { isSeparator: true, roles: ['admin', 'accountant'] },
  
   // Admin Section Separator (Optional)
   // { isSeparator: true, roles: ['admin'] },
  { isHeader: true, labelKey: "administration", roles: ['admin'] },
  { path: "/users", labelKey: "users", icon: "users", roles: ['admin'] },
  { path: "/roles", labelKey: "roles", icon: "roles", roles: ['admin'] },
  { path: "/lookups", labelKey: "lookups", icon: "lookups", roles: ['admin'] },
];

const Sidebar = ({ toggleSidebar, isSidebarOpen }) => {
    const { user } = useAuth();
    const { t } = useTranslation();
    const location = useLocation(); // Get curre

  const accessibleLinks = navLinks.filter(link =>
    !link.isSeparator && user && link.roles.includes(user.role)
  );
  const accessibleItems = navLinks.filter(item =>
    user && item.roles.includes(user.role)
  );
  return (
    // Use CSS class for styling
    <div className="sidebar-wrapper">
        {/* Brand/Logo Area */}
        <div className="sidebar-brand">
            {/* Use primary color for text */}
            {/* <span style={{ color: 'var(--primary-color)', marginRight: '0.5rem' }}></span> */}
            {/* <span style={{ color: '#eee'}}></span> */}
            {/* Or use an actual logo image */}
            <Image src={placeholderAvatar} alt="User Avatar" roundedCircle style={{height:30}} /> LMS
            {/* <img src="/path/to/logo.png" alt="FinLab Logo" height="30" /> */}
            <Button
                variant="link"
                onClick={toggleSidebar}
                className="me-2 sidebar-toggle-btn btn-outline-primary btn-sm closeBtnSidebar" // Show on all sizes for this example, adjust 'd-md-block' as needed
                aria-label="Toggle sidebar"
            >
                    {/* Toggle between Bars and Times icon */}
                {isSidebarOpen ? <FaTimes /> : <FaBars />}
            </Button>
        </div>

        {/* Navigation */}
        <Nav className="flex-column sidebar-nav">
            {accessibleItems.map((item, index) => {
                // Render Header
                if (item.isHeader) {
                    return (
                        <div key={`header-${item.labelKey}-${index}`} className="sidebar-section-header">
                            {t(item.labelKey)}
                        </div>
                    );
                }

                // Render Link Item
                const IconComponent = iconMap[item.icon] || FaCog; // Default icon
                // Determine if the link is active (handles nested routes partially)
                const isActive = location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path));

                return (
                    <Nav.Item key={item.path}>
                        {/* Using React Router Link directly and applying classes */}
                        <Link
                            to={item.path}
                            className={`nav-link ${isActive ? 'active' : ''}`} // Apply active class based on location
                        >
                            <IconComponent />
                            {t(item.labelKey)}
                        </Link>
                    </Nav.Item>
                );
             })}
        </Nav>
    </div>
  );
};

export default Sidebar;